/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API50737Req {
  
  /** 评论主键主键id */
  commentId?: number;
};



export interface API50737Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 50737 删除任务评论

export interface IUsePostAPI50737Return {
  /** 删除任务评论: 接口请求状态 */
  isAPI50737Loading: boolean;
  /** 删除任务评论: 接口请求返回数据 */
  dataAPI50737: API50737Res;
  /**  删除任务评论: 接口数据请求方法 */
  fetchAPI50737Data:  (inputs: API50737Req, config?: YWRequestConfig) => Promise<API50737Res>;
  /** 删除任务评论: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50737 = ():IUsePostAPI50737Return => {
  let isMount = true;
  const [isAPI50737Loading, setIsAPI50737Loading] = useState(false);
  const [dataAPI50737, setDataAPI50737] = useState<API50737Res>({} as API50737Res);
  const requestUrl = `${basePath}/team-work/workTask/comment/delete`;

  const fetchAPI50737Data = async (inputs: API50737Req, config?: YWRequestConfig): Promise<API50737Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50737Req>) || {}) as API50737Req;
    
  
    if ( isMount ) {
      setIsAPI50737Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50737Res>(`${basePath}/team-work/workTask/comment/delete`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50737(res || {} as API50737Res);
        setIsAPI50737Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50737Loading(false);
      }
      return false as unknown as API50737Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50737Loading,
    dataAPI50737,
    fetchAPI50737Data,
    requestUrl,
  }
}

